export function resolveQueuedOperationIdentity(
  operation: Record<string, unknown>,
  generatedOperationId: string
): {
  operationId: string;
  operation: Record<string, unknown>;
} {
  const existingOperationId =
    typeof operation.id === 'string' ? operation.id.trim() : '';

  if (existingOperationId) {
    return {
      operationId: existingOperationId,
      operation,
    };
  }

  return {
    operationId: generatedOperationId,
    operation: {
      ...operation,
      id: generatedOperationId,
    },
  };
}
